import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import Home from './components/Home/Home'
import NoMatch from './components/NoMatch/NoMatch';
import Deals from './components/Deals/Deals';
import Admin from './components/Admin/Admin';
import Login from './components/Login/Login';
import AddBook from './components/AddBook/AddBook';
import ManageBooks from './components/ManageBooks/ManageBooks';
import EditBook from './components/EditBook/EditBook';
import Orders from './components/Orders/Orders';
import { createContext } from 'react';
import { useState } from 'react';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import BookDetails from './components/BookDetails/BookDetails';
import Checkout from './components/Checkout/Checkout';


export const UserContext = createContext ();

function App() {

  const [signInUser, setSignInUser] = useState({})

  
  return (
    


    <UserContext.Provider value={[ signInUser, setSignInUser]}>

        {/* <h1>email: {signInUser.userName}</h1>  */}
         
       <Router>
         <Switch>

         <Route path="/home">
         <Home></Home>
         </Route>

         <Route path="/deals"> 
         <Deals></Deals>
         </Route>

         <PrivateRoute path="/orders/:pdId"> 
          <Orders></Orders>
         </PrivateRoute>

         <PrivateRoute path="/orders"> 
          <Orders></Orders>
         </PrivateRoute>

         <Route path="/login">
         <Login></Login>
         </Route>

         <PrivateRoute path="/checkout/:bookId">
         
         <Checkout></Checkout>
         </PrivateRoute>

         <PrivateRoute path="/admin">
         <Admin></Admin>
         </PrivateRoute>

         <Route exact path="/">
         <Home></Home>
         </Route>

         <Route path="*">
         <NoMatch></NoMatch>       
         </Route>

         </Switch>
       </Router>

     

    </UserContext.Provider>
  );
}

export default App;
